export default {
    select: "Wählen Sie Versandadresse aus",
    shippingRulesTip: "Sie müssen Ihre lokalen Vorschriften für den Versand befolgen"
}